import useStateWithStorage from "./useStateWithStorage";

const defaultPreferences = {
  checkCompatibility: {
    displayOutdated: true,
    displayDisabledFeatures: true,
    displayUnsupported: true
  }
};

function usePreferences(key) {
  const [value, setValue] = useStateWithStorage(
    key,
    "preferences",
    defaultPreferences[key]
  );

  function setValueForKey(subkey, newValue) {
    setValue(state => ({
      ...state,
      [subkey]: newValue
    }));
  }

  return [value, setValueForKey];
}

export { usePreferences };
